export default __webpack_public_path__ + "static/media/songs.97fafc62.svg";